import { render, staticRenderFns } from "./d-comments-panel.vue?vue&type=template&id=31daee10&"
import script from "./d-comments-panel.vue?vue&type=script&lang=js&"
export * from "./d-comments-panel.vue?vue&type=script&lang=js&"
import style0 from "./d-comments-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports